'use client';

import { c as _c } from "react/compiler-runtime";
import ButtonCommon from '@components/button-common/ButtonCommon';
import Portal from '@components/portal/Portal';
import { COOKIE_SECURE_FORMA_29680 } from '@lib/flags';
import { cookieContentSelector } from '@lib/store/slices/ProjectSlice';
import { handleNewUser } from '@lib/store/slices/UserSlice';
import { CookieStorage } from '@lib/tools/helpers/CookieStorage';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { generateNewUserDate, setCookie } from '@lib/tools/utils';
import cn from 'classnames';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './CookiePopupNew.module.scss';
export const CookiePopupNew = () => {
  const $ = _c(16);
  const [showDesc, setShowDesc] = useState(false);
  const cookieContent = useSelector(cookieContentSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = generateNewUserDate();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const newUserDate = t0;
  const dispatch = useDispatch();
  let t1;
  if ($[1] !== dispatch) {
    t1 = () => {
      COOKIE_SECURE_FORMA_29680 ? CookieStorage.set("moments_user", newUserDate) : setCookie("moments_user", newUserDate, 365);
      dispatch(handleNewUser({
        isANewUser: "new",
        value: true
      }));
    };
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFunction = t1;
  const isVisible = Boolean(cookieContent.title && cookieContent.description);
  const t2 = isVisible && styles.show;
  const t3 = showDesc && styles.column;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = cn(styles.container, t2, t3);
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== cookieContent.description || $[7] !== cookieContent.title || $[8] !== showDesc) {
    t5 = !showDesc ? <div className={styles.text}><SafeHtmlRenderer tag="span" content={cookieContent.title} /><span className={styles.more} onClick={() => setShowDesc(true)}>подробнее</span></div> : <><SafeHtmlRenderer tag="div" content={cookieContent.description} attributes={{
        ADD_ATTR: ["target"]
      }} className={styles.text} /><div className={styles.close} onClick={() => setShowDesc(false)} /></>;
    $[6] = cookieContent.description;
    $[7] = cookieContent.title;
    $[8] = showDesc;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleFunction) {
    t6 = <ButtonCommon className={styles.btn} handleFuction={handleFunction} text={"\u041F\u0440\u0438\u043D\u044F\u0442\u044C"} mainColor="White" />;
    $[10] = handleFunction;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Portal><div data-scroll={true} data-scroll-sticky={true} data-scroll-target="#fixed-target" className={t4}>{t5}{t6}</div></Portal>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};